<template>
  <KPaginatedAutocomplete
      v-bind="$attrs"
      v-on="$listeners"
      :paginator="autocomplete"/>
</template>

<script>
import KPaginatedAutocomplete from '@/components/crud/fields/KPaginatedAutocomplete.vue';
import { autocomplete } from '@/api/endpoints/microservice.js';

export default {
  name: 'MicroserviceAutocomplete',
  components: { KPaginatedAutocomplete },
  methods: {
    autocomplete,
  },
};
</script>

<style scoped>

</style>
